import { Text } from "sunrise-ui";
import List from "./../../utilities/List";
import { useSelector } from "react-redux";
import Modal from "./../../utilities/Modal";
import { useState } from "react";
import "./Users.scss";
import { getUserAULogs } from "../../redux/reducers/users";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useEffect } from "react";
import { getProperRole } from "../../utilities/utils";

const AssignUnassignLogs = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const listData = useSelector((state: any) => state.USERS.userAULogs);
  const [modalData, setModalData] = useState({ open: false, src: "" });
  const role = getProperRole(props.role);

  const getAllUserLogs = () => {
    dispatch(
      getUserAULogs({
        endPoint: `admin/user-assign-unassign-logs?role=${role}`,
      })
    );
  };

  useEffect(() => {
    if (role !== "") {
      getAllUserLogs();
    }
    // eslint-disable-next-line
  }, [props.role]);

  const fields = [
    {
      header: "Name",
      value: "name",
      search: true,
    },
    {
      header: "Phone No",
      search: true,
      value: "phoneNo",
    },
    { header: "Email Id", value: "emailId", search: true },
    {
      header: "Assigned From",
      value: "from",
      search: true,
    },
    {
      header: "Assigned To",
      value: "to",
      search: true,
    },
    {
      header: "Availability",
      value: "project",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className={`mt0 mb0 capitalize ${
              obj?.action !== "assigned" && "unassign"
            }`}
          >
            {obj?.action === "assigned"
              ? `Assigned to ${obj.project}`
              : `Unassigned from ${obj.project}`}
          </Text>
        );
      },
    },
    {
      header: "Photo",
      value: "userImage",
      search: true,
      action: function (obj: any) {
        return (
          <img
            src={obj?.userImage}
            className="img-log"
            alt="..."
            onClick={() => setModalData({ open: true, src: obj?.userImage })}
          />
        );
      },
    },
    {
      header: "Status",
      value: "action",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className={`mt0 mb0 capitalize ${
              obj?.action === "assigned" ? "assign" : "unassign"
            }`}
          >
            {obj?.action}!
          </Text>
        );
      },
    },
  ];

  return (
    <>
      <List
        fields={fields}
        listData={listData}
        title="Assign/Unassign History Status"
      />
      <Modal
        open={modalData.open}
        onClose={() => setModalData({ open: false, src: "" })}
      >
        <img src={modalData.src} className="modalImg" alt="..." />
      </Modal>
    </>
  );
};

export default AssignUnassignLogs;
